import React, { useEffect } from 'react'
import { Box, Typography, Grid, TextField } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { getAssociate } from '../../slices/associateApiSlice'

const ProfileSection = () => {
  const dispatch = useDispatch()
  const fullAssociateId = useSelector((state) => state.auth.user)

  useEffect(() => {
    if (fullAssociateId && fullAssociateId.startsWith('BID')) {
      const associateId = parseInt(fullAssociateId.slice(3), 10)
      if (!isNaN(associateId)) {
        dispatch(getAssociate(associateId))
      }
    }
  }, [dispatch, fullAssociateId])

  const associateDetails = useSelector(
    (state) => state.associates.associateDetails
  )

  const formatDate = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: '#F6FAFF',
        maxHeight: '80vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#AAB4C6',
          borderRadius: '10px',
          border: '2px solid #f1f1f1',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555',
        },
      }}>
      <Typography variant='h6' sx={{ fontWeight: 600, mb: 2 }}>
        Profile
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='subtitle1' sx={{ fontWeight: 500 }}>
            Basic Details
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Name'
            name='name'
            value={associateDetails?.associateBasicDetailsModel?.name || ''}
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Designation'
            name='designation'
            value={
              associateDetails?.associateBasicDetailsModel
                ?.designationCodeName || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label="Father/Husband's Name"
            name='fatherHusbandName'
            value={
              associateDetails?.associateBasicDetailsModel?.fatherHusbandName ||
              ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Occupation'
            name='occupation'
            value={
              associateDetails?.associateBasicDetailsModel?.occupation || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Date of Join'
            name='dateOfJoin'
            value={
              formatDate(
                associateDetails?.associateBasicDetailsModel?.dateOfJoin
              ) || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Wedding Anniversary'
            name='weddingAnniversary'
            value={
              associateDetails?.associateBasicDetailsModel
                ?.weddingAnniversary || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Bank Account '
            name='bankAccountNumber'
            value={
              associateDetails?.associateBasicDetailsModel
                ?.bankAccountNumber || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='subtitle1' sx={{ fontWeight: 500 }}>
            Contact Details
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Email'
            name='email'
            value={associateDetails?.associateContactDetailsModel?.email || ''}
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Phone Number 1'
            name='phoneNumber1'
            value={
              associateDetails?.associateContactDetailsModel?.phoneNumber1 || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Address'
            name='address'
            value={
              associateDetails?.associateContactDetailsModel?.address || ''
            }
            fullWidth
            multiline
            rows={3}
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='subtitle1' sx={{ fontWeight: 500 }}>
            Identity Details
          </Typography>
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='PAN Number'
            name='panNumber'
            value={
              associateDetails?.associateIdentityDetailsModel?.panNumber || ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            variant='filled'
            label='Aadhaar Number'
            name='aadhaarNumber'
            value={
              associateDetails?.associateIdentityDetailsModel?.aadhaarNumber ||
              ''
            }
            fullWidth
            sx={{ backgroundColor: '#FFFFFF', mb: 1 }}
            InputProps={{
              readOnly: true,
              style: { color: '#000000' },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ProfileSection
